import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../core/network/api';
import { repositoryKeys as keys } from '../queries/keys';
import { repositoryPaths as paths } from '../queries/paths';

export function useStandardCatalog() {
    return useQuery({
        queryKey: keys.standards,
        queryFn: async ({ signal }) => {
            const items = [];
            let offset = 0;
            for (;;) {
                const { data } = await api.get(paths.standards(), { signal, params: { limit: 100, offset } });
                const page = data.items ?? [];
                items.push(...page);
                offset += page.length;
                if (offset >= data.pagination?.total || page.length === 0) return items;
                if (!data.pagination && page.length < 100) return items;
            }
        },
    });
}

export function useStandardVersions(id) {
    return useQuery({
        queryKey: keys.standardVersions(id), enabled: !!id,
        queryFn: ({ signal }) => api.get(paths.standardVersions(id), { signal }).then(r => r.data.items ?? []),
    });
}

export function useStandardVersion(id) {
    return useQuery({
        queryKey: keys.standardVersion(id), enabled: !!id,
        queryFn: ({ signal }) => api.get(paths.standardVersion(id), { signal }).then(r => r.data),
    });
}

export function usePinStandard(repositoryId) {
    const qc = useQueryClient();
    return useMutation({
        retry: false,
        mutationFn: async (payload) => {
            await api.post(paths.pinStandard(), { repository_id: repositoryId, ...payload });
            const { data } = await api.get(paths.detail(repositoryId));
            const repository = data.repository ?? data;
            if (repository.standard_version_id !== payload.standard_version_id) {
                throw new Error('La lectura del repositorio no confirma la versión elegida. Recarga antes de reintentar.');
            }
            qc.setQueryData(keys.detail(repositoryId), data);
            return repository;
        },
        onSettled: () => qc.invalidateQueries({ queryKey: keys.all }),
    });
}
